import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import Loading from '@/components/Loading.vue';
import store from '@/store';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const isLoading = ref(false);

const init = async () => {
  isLoading.value = true;
  try {
    await Promise.all([
      store.dispatch('careerSheetDesired/getDesiredCondition'),
      store.dispatch('master/getMasterDataListIndsctg'),
      store.dispatch('master/getMasterDataOcupClass'),
      store.dispatch('master/getMasterDataListEmpTypeBusicr'),
      store.dispatch('master/getMasterDataListPref'),
      store.dispatch('userMenu/receive'),
    ]);
  } catch (e) {
    console.error(e);
  } finally {
    isLoading.value = false;
  }
};
init();

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
    (!isLoading.value)
      ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}
}

})